import type { Page } from '../../types';

const nominatorDetails: Page[] = [
  {
    pageType: 'question',
    title: 'Nominator details',
    name: 'nominator-details',
    questions: [
      {
        questionType: 'athenaNominatorLookup',
        title: 'Search for nominator by name or email',
        name: 'nominator-lookup',
        hint:
          'It may take a few seconds to look up the staff record. Please click on the correct record when visible\n\n' +
          'This is the email address of the person making the nomination, In most cases this will be your details, unless you are filling the form in on behalf of someone else.',
        searchPlaceholder: 'Please enter a name or email address',
        fuzzyMatch: true,
        matchLimit: 5,
        errorMessages: {
          required: 'You must click on a user from the lookup results',
        },
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Nominator full name',
        name: 'nominator-full-name',
        readOnly: true,
        hideOptionalLabel: true,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Nominator email address',
        name: 'nominator-email',
        readOnly: true,
        hideOptionalLabel: true,
      },
      {
        questionType: 'checkbox',
        title:
          'Please tick this box to confirm that you are making this nomination on behalf of {nominator-email}',
        name: 'nominator-on-behalf-confirmation',
        options: ['I confirm'],
        disabled: [
          {
            field: 'nominator-email',
            condition: 'equals',
            value: '',
          },
          {
            field: 'nominator-email',
            condition: 'equalsField',
            value: 'submitter-email',
          },
        ],
        rules: {
          required: true,
        },
        errorMessages: {
          required: 'You must confirm that you are making this nomination on behalf of the nominator',
        },
      },
    ],
  },
];

export default nominatorDetails;
